import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Nav from "./components/navBar/Nav";
import EnFooter from "./components/footer/Footer";
import useAuth from "./hooks/useAuth";
import axios from "./api/axios";
import { getResiWidgetScriptUrl } from "./config/resibotWidgetUrl";
import { getWidgetTenantId } from "./config/resibotTenantId";

const RESIBOT_API_URL = process.env.REACT_APP_RESIBOT_API_URL || "";
const DASHBOARD_KEY_URL = "/dashboard/key";

const Layout = ({ primaryColor, siteName }) => {
  const { username } = useAuth();
  const [outletRendered, setOutletRendered] = useState(false);
  const [showResiBot, setShowResiBot] = useState(false);

  useEffect(() => {
    setOutletRendered(true);
  }, []);

  useEffect(() => {
    const addGoogleTranslateScript = () => {
      if (window.google && window.google.translate) return;

      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    };

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    };

    addGoogleTranslateScript();
  }, []);

  useEffect(() => {
    if (!username) return;
    axios
      .get(DASHBOARD_KEY_URL, { params: { username, key: "showResiBot" } })
      .then((res) => {
        setShowResiBot(res?.data?.showResiBot ?? true);
      })
      .catch(() => setShowResiBot(true));
  }, [username]);

  useEffect(() => {
    const widgetSrc = getResiWidgetScriptUrl();
    if (!showResiBot || !widgetSrc || !RESIBOT_API_URL || !username) return;
    if (document.getElementById("resi-widget-script")) return;

    const tenantIdForWidget = getWidgetTenantId(username);

    const script = document.createElement("script");
    script.id = "resi-widget-script";
    script.src = widgetSrc;
    script.setAttribute("data-tenant-id", tenantIdForWidget);
    script.setAttribute("data-api-url", RESIBOT_API_URL);
    if (siteName) script.setAttribute("data-name", siteName);
    if (primaryColor) script.setAttribute("data-primary-color", primaryColor);
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      const el = document.getElementById("resi-widget-script");
      if (el) el.remove();
      const root = document.getElementById("resi-widget-root");
      if (root) root.remove();
    };
  }, [showResiBot, username, primaryColor, siteName]);

  return (
    <main>
      <Nav />
      <Outlet />
      {outletRendered && <EnFooter />}
    </main>
  );
};

export default Layout;
